import classNames from 'classnames'
import styles from './Skeleton.module.scss'
import type { SkeletonProps } from './types'

const Skeleton = ({className, width = 200, height = 200, children, animated = true }: SkeletonProps) => {
  return (
    <div className={classNames(styles['pintxo-skeleton'], className)} data-animated={animated}>
      {children || (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height}>
          <g>
            <rect className={styles['pintxo-skeleton-shape']} height={height} width={width} y="0" x="0" />
          </g>
        </svg>
      )}
    </div>
  )
}

export default Skeleton
